import type { HubMissao } from '../types'

function formatPrazo(iso: string | null): string {
  if (!iso) return 'Sem prazo'
  const [y, m, d] = iso.slice(0, 10).split('-')
  if (!y || !m || !d) return 'Sem prazo'
  return `Prazo ${d}/${m}`
}

type Props = {
  items: HubMissao[]
  compact?: boolean
  busyId?: number | null
  onConcluir: (id: number) => void
}

export function MissoesList({ items, compact, busyId, onConcluir }: Props) {
  if (items.length === 0) {
    return <p className="bp-muted">Nenhuma missão ativa no momento.</p>
  }

  return (
    <ul className="bp-people">
      {items.map((m) => (
        <li key={m.id_missao}>
          <div className="bp-person" style={{ alignItems: 'flex-start' }}>
            <span style={{ flex: 1 }}>
              <strong>
                {m.titulo}
                {m.ja_concluiu ? ' ✓' : ''}
              </strong>
              <span className="bp-muted">
                {formatPrazo(m.data_prazo)}
                {m.pontos > 0 ? ` · ${m.pontos} pts` : ''}
              </span>
              {!compact && m.descricao ? (
                <span className="bp-muted" style={{ whiteSpace: 'pre-wrap' }}>
                  {m.descricao}
                </span>
              ) : null}
            </span>
            {m.ja_concluiu ? (
              <span className="bp-muted">Feito</span>
            ) : (
              <button
                type="button"
                className="bp-btn bp-btn--primary"
                disabled={busyId === m.id_missao}
                onClick={() => onConcluir(m.id_missao)}
              >
                {busyId === m.id_missao ? '…' : 'Concluir'}
              </button>
            )}
          </div>
        </li>
      ))}
    </ul>
  )
}
